/**
 * convertIsoDateTimeToTimestamp
 *
 * Converts a given iso date and time into a UTC timecode
 *
 * @return {}
 */

OT.createNS('OT.Search.Helpers');

OT.Search.Helpers.convertIsoDateTimeToTimestamp = function (date, time) {
    var time24Hours = OT.Search.Helpers.convertTimeTo24Hour(time);
    var datetime = date + ' ' + time24Hours;
    return moment(datetime, 'YYYY-MM-DD').format('X');
};
